import type { Database } from "@/integrations/supabase/types";

type JudgeRow = Database["public"]["Tables"]["judges"]["Row"];

export type Judge = Omit<
	JudgeRow,
	"openrouter_api_key_configured" | "model" | "max_tokens" | "temperature"
> & {
	openrouter_api_key_configured: boolean;
	model: string;
	max_tokens: number;
	temperature: number;
	owner_email?: string | null;
};

export const normalizeJudge = (
	judge: JudgeRow,
	ownerEmail?: string | null,
): Judge => ({
	...judge,
	openrouter_api_key_configured: Boolean(judge.openrouter_api_key_configured),
	model: judge.model ?? "openai/gpt-4o-mini",
	max_tokens: judge.max_tokens ?? 1000,
	temperature: judge.temperature ?? 0.7,
	owner_email: ownerEmail ?? null,
});
